exports.onRouteUpdate = ({ location, prevLocation }) => {
  const maxAttempts = 3;
  let attempt = 0;
  const recordPage = () => {
    try {
      window.lucid.beacon.recordPageChange(location.href);
    } catch (e) {
      if (attempt < maxAttempts) {
        attempt += 1;
        setTimeout(() => recordPage(), 100);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  };
  if (typeof window !== `undefined`) {
    if (
      prevLocation &&
      window.lucid &&
      window.lucid.beacon &&
      window.lucid.beacon.recordPageChange
    ) {
      setTimeout(() => recordPage(), 100);
    }
  }
};
